/** A bounded data contract, shared by browser collection and server recipient transforms. */
export type ProcessingField = {
  name: string;
  type: "number" | "boolean" | "enum";
  values: string[];
};
export function processingProperties(
  fields: ProcessingField[] | undefined,
  input: Record<string, unknown> | null | undefined,
) {
  const output: Record<string, number | boolean | string> = {};
  for (const field of fields ?? []) {
    const value = input?.[field.name];
    if (
      field.type === "number" &&
      typeof value === "number" &&
      Number.isFinite(value)
    )
      output[field.name] = value;
    else if (field.type === "boolean" && typeof value === "boolean")
      output[field.name] = value;
    else if (
      field.type === "enum" &&
      typeof value === "string" &&
      field.values.includes(value)
    )
      output[field.name] = value;
  }
  return output;
}

export type ProcessingIdentifier =
  "gaClientId" | "gaSessionId" | "fbp" | "fbc" | "gclid" | "ttclid";
export function processingIdentifiers(
  allowed: ProcessingIdentifier[] | undefined,
  input: Record<string, unknown> | null | undefined,
  advertising: boolean,
) {
  const result: Record<string, string> = {};
  for (const key of allowed ?? []) {
    if (!advertising && !["gaClientId", "gaSessionId"].includes(key)) continue;
    const value = input?.[key];
    if (typeof value !== "string" || value.length > 256) continue;
    const valid =
      key === "gaClientId"
        ? /^\d{1,20}\.\d{1,20}$/.test(value)
        : key === "gaSessionId"
          ? /^\d{1,20}$/.test(value)
          : /^[A-Za-z0-9_.-]{1,256}$/.test(value);
    if (valid) result[key] = value;
  }
  return result;
}
